(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-richtext"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCollapsibleRichtext(scope) {
      var roots = (scope || document).querySelectorAll('[data-collapsible-richtext]');
      roots.forEach(function (root) {
        if (root.dataset.collapsibleReady === 'true') return;
        root.dataset.collapsibleReady = 'true';

        var body = root.querySelector('[data-collapsible-body]');
        var toggle = root.querySelector('[data-collapsible-toggle]');
        if (!body || !toggle) return;

        function sync() {
          if (root.classList.contains('is-expanded')) return;
          var overflows = body.scrollHeight > body.clientHeight + 2;
          root.classList.toggle('is-clamped', overflows);
          toggle.hidden = !overflows;
        }

        toggle.addEventListener('click', function () {
          var expanded = root.classList.toggle('is-expanded');
          if (expanded) root.classList.remove('is-clamped');
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
          if (!expanded) sync();
        });

        sync();
        window.addEventListener('resize', sync);
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(sync);
        }
      });
    }

    initCollapsibleRichtext(document);
    document.addEventListener('shopify:section:load', function (event) {
      initCollapsibleRichtext(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
